<mat-toolbar class="subtitulo">Reunião</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">

        <mat-horizontal-stepper #stepper style="background: transparent; padding: 10px">

                <mat-step style="padding-bottom: 20px" [stepControl]="formCadastroReuniao">
                        <form #formCadastroReuniao="ngForm" state="dadosReuniao">
                                <ng-template matStepLabel>Reunião</ng-template>

                                <dados-reuniao [reuniao]=reuniao></dados-reuniao>
                                <div dir="rtl" fxLayoutGap="20px"
                                        style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
                                        <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                                                <mat-icon>chevron_right</mat-icon>
                                        </button>
                                </div>
                        </form>
                </mat-step>


                <mat-step style="padding-bottom: 20px" [stepControl]="formCadastroAcaoReuniao">
                        <form #formCadastroAcaoReuniao="ngForm" state="dadosAcaoReuniao">
                                <ng-template matStepLabel>Próximas Ações</ng-template>

                                <acao-reuniao [reuniao]=reuniao></acao-reuniao>
                                <div dir="rtl" fxLayoutGap="20px"
                                        style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
                                        <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                                                <mat-icon>chevron_right</mat-icon>
                                        </button>
                                </div>
                        </form>
                </mat-step>

        </mat-horizontal-stepper>

        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                fxFlexFill>
                <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" 
                        [disabled]="formCadastroReuniao.invalid || formCadastroAcaoReuniao.invalid"
                        mat-raised-button name="botaoConfirmar" 
                        fxFlex="20%" 
                        color="primary" 
                        (click)="cadastrar()">
                        Cadastrar
                </button>

                <button *ngIf="isAtualizar && mostrarBotaoAtualizar" 
                        [disabled]="formCadastroReuniao.invalid || formCadastroAcaoReuniao.invalid"
                        mat-raised-button 
                        name="botaoConfirmar" 
                        fxFlex="20%" 
                        color="primary" 
                        (click)="atualizar()">
                        Atualizar
                </button>

                <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                        Limpar
                </button>
                <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                        Cancelar
                </button>

        </div>


</div>
